/**
 * Shared voice recording primitives — namespace-agnostic browser audio
 * capture + Whisper transcription. Used by both chatbot (`features/chatbot`)
 * and agent runner (`features/agents`) without coupling to either's i18n
 * namespace.
 *
 * @module lib/voice
 */

export {
  useVoiceRecorder,
  type UseVoiceRecorderOptions,
  type UseVoiceRecorderReturn,
  type VoiceErrorKey,
} from './useVoiceRecorder';

export { VoiceRecordButton, type VoiceLabels } from './VoiceRecordButton';
export { useVoiceLabels } from './useVoiceLabels';
